define(
    'widgets/document_results_heading/viewmodel',[
        "services/service.folders",
        "providers/dataprovider",
        "i19n!i19n/strings"
    ],
    function (foldersService, dataProvider, i19n) {
    
    var Widget = function () {};

    Widget.prototype.activate = function (settings) {
        var self = this;

        self.i19n = i19n;

        // observables
        self.dText = settings.filter.default.text;
        self.dClick = settings.filter.default.click;
        self.eText = settings.filter.email.text;
        self.eClick = settings.filter.email.click;
        self.cText = settings.filter.controlled.text;
        self.cClick = settings.filter.controlled.click;
        self.wText = settings.filter.working.text;
        self.wClick = settings.filter.working.click;

        self.data = !ko.isObservable(settings.data) ? ko.observable(settings.data) : settings.data;
        self.subheading = settings.subheading;

        self.heading = ko.computed(function () {
            if (self.data() != null) {
                if (self.data().label !== undefined) {
                    return self.data().label();
                } else if (self.data().name !== undefined) {
                    return self.data().name();
                }
            }
            return null;
        });

        self.favouritingEnabled = ko.computed(function () {
            return self.heading() && self.data() != null && (self.data().folderId !== undefined || self.data().savedSearchId !== undefined);
        });
        self.isFavourite = ko.computed(function () {
            return self.heading() && self.data() != null && self.data().isFavourite !== undefined && self.data().isFavourite();
        });
        self.toggleFavorite = function () {
            var toggle = !self.isFavourite();

            self.data().isFavourite(toggle);

            if (self.data().removeFolder !== undefined) {
                self.data().removeFolder({ folderId: self.data().folderId, libraryId: self.data().libraryId, toggle: !toggle });
            }

            if (self.data().removeSearch === undefined) {
                if (toggle)
                    foldersService.favouriteFolder(self.data().folderId, '');//foldersService.favouriteFolder(self.data().folderId, self.data().name());
                else
                    foldersService.unfavouriteFolder(self.data().folderId);
            } else {
                if (toggle) {
                    dataProvider.search
                    .saveSearchMetadata({ query: self.data().query })
                    .done(function (id) {
                        self.data().savedSearchId = id;
                        self.data().q.savedSearchId = id;
                        self.data().removeSearch({ savedSearchId: id, toggle: !toggle });
                    })
                    .fail(function (e) {
                        console.error(e);
                    });
                    
                } else {
                    dataProvider.search
                    .deleteSearchMetadata({ id: self.data().savedSearchId })
                    .done(function (data) {
                        self.data().removeSearch({ savedSearchId: self.data().savedSearchId, toggle: !toggle });
                    })
                    .fail(function (e) {
                        console.error(e);
                    });
                }
            }
        };
    };

    return Widget;
});
